<mat-toolbar color="accent">Approve MOH Prior Approval</mat-toolbar>

<div class="flex flex-col gap-4 p-4">
  <form [formGroup]="form">
    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-label>Approval Number</mat-label>
      <input matInput formControlName="approvalNumber" />
    </mat-form-field>
  </form>

  <span class="font-bold opacity-90">Attachments</span>

  <pt-attachments
    [uploadPath]="storagePath"
    [attachments]="attachments$ | async"
    (attachmentAdded)="addAttachment($event)"
    (attachmentRemoved)="removeAttachment($event)"
  />

  <pt-buttons-container>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
  </pt-buttons-container>
</div>
